<!-- /* [MATCH-ACCEPT-C-POP] 승인서 작성(기업) */ -->

<template>
  <BasicAlertModal
    :isShowModal="isModal"
    @close-modal="$store.commit('directMatching/setHideModalPopup')"
    btnSubmitText="확인"
    :handleSubmit="handleDelete"
  >
    Are you sure you want to delete, <br /><br />

    계속진행하시겠습니까?
  </BasicAlertModal>
</template>

<script>
import BasicAlertModal from "@/components/modal/BasicAlertModal.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: { BasicAlertModal },
  name: "DirectDeletePopup",
  props: {
    isModal: Boolean,
  },
  computed: {
    ...mapState("directMatching", ["selectedDirectMatching"]),
  },
  methods: {
    ...mapActions("directMatching", ["deleteDirectMatching"]),
    handleDelete() {
      this.deleteDirectMatching(this.selectedDirectMatching.idx)
        .then(() => {
          this.$emit("removeItem");
        })
        .finally(() => {
          this.$store.commit("directMatching/setHideModalPopup");
        });
    },
  },
  watch: {
    isModal(val) {
      if (!val) this.form = {};
    },
  },
};
</script>
